import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const isProjectPage = pathname.startsWith("/projects/");

    if (isProjectPage) {
      window.scrollTo({ top: 0, behavior: "auto" });
    } else if (hash) {
      // Attendre que le DOM soit prêt avant de scroll
      const scrollToHash = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      };
      setTimeout(scrollToHash, 100);
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollHandler;
